<template>
  <div></div>
</template>
<script>

import { setIdToken, setAccessToken, getParameterByName, fetchTargetPath, clearTargetPath, getUserId, initialiseProfile } from '@/utils/auth'
import { countQueries, createQueries } from '@/utils/queries-api'
import { statusEnum } from '@/utils/api-common'
import { defaultQueriesForStoring } from '@/graph_parts/default_queries'
import { fetchUserDetails } from '@/utils/user-details'

function installBaseQueries (cb) {
  countQueries().then(r => {
    if (r.status === statusEnum.ok && r.response.count <= 0) {
      const ownerId = getUserId()
      const queries = defaultQueriesForStoring().map(q => {
        q.ownerId = ownerId
        q._id = null
        q.updatedAt = new Date()
        return q
      })
      createQueries(queries).then(rs => {
        rs.forEach(r => {
          if (typeof r.status === 'undefined' || r.status !== 200) {
            console.warn('Failed to create strategy', r)
          }
        })
        cb()
      })
    } else {
      cb()
    }
  })
}

export default {
  name: '',
  beforeRouteEnter () {
    if (getParameterByName('error') !== null) {
      // Clear out item added by auth0 that causes endless loop otherwise if user declines after registering
      // see also https://github.com/auth0/auth0.js/issues/402
      const state = getParameterByName('state')
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('com.auth0.auth')) {
          const valueString = localStorage.getItem(key)
          const value = JSON.parse(valueString)
          if (value && typeof value.state !== 'undefined' && value.state === state) {
            localStorage.removeItem(key)
          }
        }
      })
      window.location.href = '/'
    } else {
      setAccessToken()
      setIdToken()
      const targetPath = fetchTargetPath()
      clearTargetPath()
      initialiseProfile(() => {
        installBaseQueries(() => {
          window.location.href = targetPath === null ? '/starter-query' : targetPath
        })
        fetchUserDetails()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/callback.vue